export default __webpack_public_path__ + "static/media/deliland-wholeflour-icon.369bd7f1.png";